import React from 'react';
import { connect } from 'react-redux';
import { List, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutlineRounded';
import TextElementListItem from './TextElementListItem';
import { createActions } from '../../store';

class TextElementsEditor extends React.Component {
    render() {
        const { textElementsLength, advanced, addTextElement, removeTextElement, duplicateTextElement } = this.props
        const indexes = Array.from({length: textElementsLength}, (_, i) => i);

        return (
            <>
                <List
                    dense
                    disablePadding
                >
                    {indexes.map((index) =>
                        <TextElementListItem
                            key={index}
                            index={index}
                            advanced={advanced}
                            remove={() => removeTextElement(index)}
                            duplicate={textElementsLength < 7 ? () => duplicateTextElement(index) : null}
                        />
                    )}
                </List>
                {advanced ?
                    <>
                        <br/>
                        <Button 
                            startIcon={<AddIcon />} 
                            size='small'
                            disabled={textElementsLength >= 7}
                            onClick={() => addTextElement()}
                        >
                            Add Text
                        </Button>
                    </>
                : null}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { length: textElementsLength } = state.createPreview.present.videoSettings.text.textElements;
    return { textElementsLength };
}

const mapDispatchToProps = (dispatch) => {
    const addTextElement = () => dispatch(createActions.addTextElement());
    const removeTextElement = (index) => dispatch(createActions.removeTextElement(index));
    const duplicateTextElement = (index) => dispatch(createActions.duplicateTextElement(index));

    return {
        addTextElement,
        removeTextElement,
        duplicateTextElement
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextElementsEditor);